class DeliveryDate extends HTMLElement {
    constructor() {
      super();
      this.datepicker = this.querySelector("[data-datepicker]");
      this.timePicker = this.querySelector("[data-time-picker]");
      document.addEventListener("click", this.onPickerWrapper.bind(this));

      this.CUTOFF_HOUR_24H = 16; // 4 PM
    }

    connectedCallback() {
        this.init();
    }

    onPickerWrapper(e) {
      const target = e.target.closest(".date-picker-wrapper");
      console.log(target)
      if(!target) return;
      e.preventDefault();
      $(this.datepicker).datepicker("show");
    }

    init() {
      this.today = new Date();
      // this.today = new Date('2025-06-27T19:30:00');   TO TEST THE DATE CHANGE
      
      // Check if current time is after 7 PM
      if (this.today.getHours() >= this.CUTOFF_HOUR_24H) {
        this.today.setDate(this.today.getDate() + 1);
      }
    
      this.minDate = this.today;
      this.maxDate = new Date(this.today); // copy the updated today
      this.maxDate.setDate(this.minDate.getDate() + 2);
    
      this.datepicker.addEventListener("keydown", this.datepickerKeydown.bind(this));
      this.datepicker.addEventListener("paste", (e) => e.preventDefault());
    
      $(this.datepicker).datepicker({
        minDate: this.minDate,
        maxDate: this.maxDate,
        dateFormat: "yy-mm-dd",
        onSelect: (selectedDate) => this.updateTimeSlots(selectedDate)
      });
    
      this.datepicker.addEventListener("change", () => {
        const selectedDate = new Date(this.datepicker.value);
        if (
          selectedDate < this.minDate ||
          selectedDate > this.maxDate ||
          isNaN(selectedDate.getTime())
        ) {
          this.datepicker.value = "";
          this.timePicker.value = "";
        }
      });

      this.enableCheckoutButton();
    }

    enableCheckoutButton() {
      if(document.readyState == "complete") {
        const checkoutButton = document.querySelector(`[id="checkout"]`);
        if(checkoutButton) {
          checkoutButton.hidden = false;
        }
      } else {
        window.addEventListener("load", () => this.enableCheckoutButton());
      }
    }
  
    datepickerKeydown(e){
      e.preventDefault(); // Optional: block actual input if needed
      if (e.key === "Backspace" || e.key === "Delete") {
        this.datepicker.value = "";
      }
    }

    updateTimeSlots(selectedDateStr) {
        const selectedDate = new Date(selectedDateStr);
        const now = new Date();

        const options = Array.from(this.timePicker.querySelectorAll("option"));
        let availableOptions = [];

        options.forEach(option => {
            option.disabled = false;
            option.hidden = false;
        });

        // If selected date is today, filter based on time
        if (this.isSameDate(selectedDate, now)) {
            const currentTime = now.getHours() * 60 + now.getMinutes();

            options.forEach(option => {
                const fromTime = this.parseTime(option.getAttribute("to"));
                console.log({fromTime, currentTime});
                if (fromTime <= currentTime) {
                    option.disabled = true;
                    option.hidden = true;
                }
            });
        }

        // Find available (visible + enabled) options
        availableOptions = options.filter(opt => !opt.disabled && !opt.hidden);

        // Auto-select if only one option remains
        if (availableOptions.length === 1) {
            availableOptions[0].selected = true;
        } else {
            this.timePicker.value = ""; // Reset selection
            availableOptions[0].selected = true;
            
        }
    }

    parseTime(timeStr) {
        const [time, period] = timeStr.trim().split(" ");
        let [hours, minutes] = time.split(":").map(Number);

        if (period === "PM" && hours !== 12) hours += 12;
        if (period === "AM" && hours === 12) hours = 0;

        return hours * 60 + minutes;
    }

    isSameDate(d1, d2) {
        return (
            d1.getFullYear() === d2.getFullYear() &&
            d1.getMonth() === d2.getMonth() &&
            d1.getDate() === d2.getDate()
        );
    }
}

if (!customElements.get("delivery-date")) {
    customElements.define("delivery-date", DeliveryDate);
}